import React, {FC, ReactElement} from 'react';
import {IMenuBarItem, MenuSettingsChildren} from "@ui/menuBarCustom/types";
import CloseIcon from '@mui/icons-material/Close';

import {sx} from './sx'
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";

import {Box, Menu, MenuItem, Stack} from "@mui/material";
import TooltipCustom from "@ui/tooltipCustom/TooltipCustom";
import {MoreHorizIcon} from "@ui/icons/icons";
import {SxType} from "@baseTypes/sx/sxTypes";


interface IProps {
    children?: MenuSettingsChildren,
    button?: ReactElement,
    name?: string,
    items?: IMenuBarItem[],
    size?: 'medium' | 'small' | 'large',
    buttonClose?: boolean,
    tooltip?: string,
    arrow?: boolean,
    empty?: boolean,
    disabled?: boolean,
    sx?: SxType
}

const MenuBarCustom: FC<IProps> = ({
                                       children,
                                       button,
                                       name,
                                       items,
                                       size = 'medium',
                                       buttonClose,
                                       tooltip,
                                       arrow = false,
                                       empty,
                                       disabled,
                                       sx: sxProps = {},
                                       ...rest
                                   }) => {


    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        if (disabled) {
            return
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const btn = button ? button :
        <IconButtonCustom
            variant={'empty'}
        >
            <MoreHorizIcon/>
        </IconButtonCustom>;

    const list = items?.length && items.map((item, index) => {

        const {closeMenu, component, sx} = item;

        if (closeMenu) {
            return <MenuItem
                sx={sx}
                key={index}
                onClick={handleClose}>
                {component}
            </MenuItem>
        }

        return <MenuItem
            key={index}
            sx={sx}
        >
            {React.cloneElement(component, {
                closeMenuFn: () => {
                    handleClose();
                },
            })}
        </MenuItem>

    })


    return (
        <Box sx={sxProps}>
            <TooltipCustom
                title={tooltip}
            >
                <Box
                    onClick={handleClick}
                    sx={{...sxProps?.button, ...sx?.button}}
                >
                    {btn}
                </Box>
            </TooltipCustom>

            <Menu
                {...rest}
                sx={{
                    ...sx.root,
                    paddingTop: buttonClose ? '30px' : '15px'
                }}
                transitionDuration={700}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {buttonClose &&
                    <Stack
                        sx={sx.innerBtn}
                        direction={'row'}
                        justifyContent={'flex-end'}
                    >
                        <IconButtonCustom
                            onClick={handleClose}
                            size={size}
                            color={'#f5f3f0'}
                        >
                            <CloseIcon
                                sx={sx.iconClose}
                            />
                        </IconButtonCustom>
                    </Stack>}

                {typeof children === 'function' && children({closeMenuFn: handleClose})}
                {(typeof children !== 'function' && children) && children}
                {list?.length >= 1 && list}
            </Menu>
        </Box>
    );
};

export default MenuBarCustom;